import { MDBCol, MDBRow } from "mdbreact";
import React from "react";
import logo_medpro from "~/assets/img/desktop/icon/logo.svg";
import styles from "./styles.module.scss";

import { size } from "lodash";
import { Image } from "semantic-ui-react";

import bocongthuong1 from "~/assets/img/mobile/logo/bocongthuong1.svg";
import bocongthuong2 from "~/assets/img/mobile/logo/bocongthuong2.svg";

const FooterDesktop = ({ data }) => {
  // const router = useRouter()
  return (
    <MDBRow gutter={[10, 10]} className={styles.pc}>
      <MDBCol span={24} className={styles.info}>
        <a
          href="https://medpro.vn"
          target="_blank"
          rel="noreferrer"
          className={styles.logoFooter}
        >
          <Image
            src={logo_medpro}
            width={220}
            height={96}
            layout="responsive"
            alt="Logo Medpro Footer"
          />
        </a>
        <ul>
          <li>
            <span>Địa chỉ: </span>
            236/29/18 Điện Biên Phủ - Phường 17 - Quận Bình Thạnh - TPHCM.
          </li>
          {/* )} */}

          <li>
            <span>Website: </span>
            https://medpro.vn
          </li>
          <li>
            <span>Email: </span>
            cskh@medpro.vn
          </li>
          <li>
            <span>Điện thoại: </span>
            (028) 710 78098
          </li>
        </ul>
      </MDBCol>
      <MDBCol span={24} offset={2} className={styles.menuFooter}>
        <MDBRow gutter={[16, 16]}>
          {data?.menu?.map((item, index) => (
            <MDBCol key={index} xl={4} md={4}>
              {/* {router.asPath === "/" ? ( */}
              {/* <h3 className={styles.title}>{item?.title}</h3> */}
              {/* ) : (
                  <div className={styles.title}>{item?.title}</div>
                )} */}
              <div className={styles.title}>{item?.title}</div>
              {size(item?.children) > 0 && (
                <ul>
                  {item?.children?.map((el, i) => (
                    <li key={i}>
                      <a
                        href={el.link}
                        target="_blank"
                        rel="noreferrer nofollow"
                      >
                        {el.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </MDBCol>
          ))}
          <MDBCol xl={6} md={6}>
            <div className={styles.order}>
              <div className={styles.groupCertificate}>
                <a
                  href={data?.downloads?.dkbct}
                  rel="noreferrer nofollow"
                  target="_blank"
                >
                  <Image
                    src={bocongthuong1}
                    width={97}
                    height={30}
                    layout="responsive"
                    alt="Đã đăng kí bộ công thương"
                  />
                </a>
              </div>
              <div className={styles.groupCertificate}>
                <a
                  href={data?.downloads?.tbbct}
                  rel="noreferrer nofollow"
                  target="_blank"
                >
                  <Image
                    src={bocongthuong2}
                    width={97}
                    height={30}
                    layout="responsive"
                    alt="Đã thông báo bộ công thương"
                  />{" "}
                </a>
              </div>
              <div className={styles.groupCertificate}>
                <a
                  href={data?.downloads?.ios}
                  rel="noreferrer nofollow"
                  target="_blank"
                >
                  <Image
                    src="https://bo-api.medpro.com.vn/static/images/medpro/web/icon_ios.svg?t=11111111"
                    width={97}
                    height={28}
                    layout="responsive"
                    alt="Tải ứng dụng App Store"
                  />{" "}
                </a>
              </div>
              <div className={styles.groupCertificate}>
                <a
                  href={data?.downloads?.android}
                  rel="noreferrer nofollow"
                  target="_blank"
                >
                  <Image
                    src="https://bo-api.medpro.com.vn/static/images/medpro/web/icon_google_play.svg?t=1111111"
                    width={97}
                    height={28}
                    layout="responsive"
                    alt="Tải ứng dụng Google Play"
                  />{" "}
                </a>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  );
};
export default FooterDesktop;
